"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeleteContent = void 0;
var UserActionEvent = _interopRequireWildcard(require("@ori-events/user-action"));
var _components = require("@ori-ui/components");
var _auth = require("@ori/auth");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _react = require("react");
var _constants = require("../../constants");
var _favoritesContext = require("../../contexts/favoritesContext");
var _hooks = require("../../hooks");
var _constants2 = require("../CreateOrEditContent/constants");
var _FavoritesDialogContent = require("../FavoritesDialogContent/FavoritesDialogContent");
var _constants3 = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const DeleteContent = ({
  lastUsedListId,
  shouldRedirectOnSuccess,
  onDialogClose
}) => {
  const {
    customerId
  } = (0, _auth.useToken)();
  const globalApiClient = (0, _globalApiClientReact.useApiClient)();
  const {
    translations,
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    getList,
    openSnackbar,
    updateLists
  } = (0, _favoritesContext.useFavorites)();
  const list = getList(lastUsedListId);
  const onDeleteList = (0, _react.useCallback)(async () => {
    try {
      await (0, _globalApiClientReact.deleteCustomerProductListTypeProductList)(globalApiClient, customerId, 'Personal', lastUsedListId);
      openSnackbar(translations.deleteSuccess);
      // istanbul ignore next @preserve --We are not testing the else case
      updateLists(lists => lists.filter(({
        id
      }) => id !== lastUsedListId));
      if (shouldRedirectOnSuccess) {
        window.location.href = _constants.FAVORITE_LISTS_LANDING_PAGE;
      }
    } catch (error) {
      openSnackbar(translations.deleteFailed);
    } finally {
      UserActionEvent.dispatch([_constants2.ANALYTICS_EVENT_MANAGE, window.location.pathname, _constants2.ANALYTICS_EVENT_MANAGE_DELETE_LIST]);
      onDialogClose();
    }
  }, [customerId, globalApiClient, lastUsedListId, onDialogClose, openSnackbar, shouldRedirectOnSuccess, translations.deleteFailed, translations.deleteSuccess, updateLists]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FavoritesDialogContent.FavoritesDialogContent, {
    testId: _constants3.DELETE_CONTENT,
    message: formatMessage('deleteDescription', {
      listName: list?.name
    }),
    content: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
        fullWidth: true,
        variant: "contained",
        color: "error",
        onClick: onDeleteList,
        children: translations.delete
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
        fullWidth: true,
        variant: "text",
        onClick: onDialogClose,
        children: translations.cancel
      })]
    })
  });
};
exports.DeleteContent = DeleteContent;
//# sourceMappingURL=DeleteContent.js.map